export const PASTURE_STATES = [
    { state: 'livestock', color: '#32CD32B3', faIcon: 'fad fa-sheep', t: '2637' },
    { state: 'grazing', color: '#32CD32B3', faIcon: 'fad fa-sheep', t: '1822' }, // LimeGreen with 70% opacity
    { state: 'resting', color: '#ADFF2FB3', faIcon: 'fad fa-campground', t: '1834' }, // GreenYellow with 70% opacity
    { state: 'cropping', color: '#FFD700B3', faIcon: 'fad fa-tractor', t: '2883' }, // Gold with 70% opacity
    { state: 'non-agricultural', color: '#A9A9A9B3', faIcon: 'fad fa-campground', t: '5383' },
    { state: 'hay', color: '#F4A460B3', faIcon: 'fad fa-blanket', t: '2884' }, // SandyBrown with 70% opacity
    { state: 'silage', color: '#006400B3', faIcon: 'fad fa-axe', t: '1850' }, // DarkGreen with 70% opacity
    { state: 'fallow', color: '#A0522DB3', faIcon: 'fad fa-knife-kitchen', t: '1851' }, // Sienna (terracotta/tilled soil) with 70% opacity
    { state: 're-seeding/renovation', color: '#87CEFAB3', faIcon: 'fad fa-seedling', t: '1852' }, // LightSkyBlue with 70% opacity
    { state: 'fertilization', color: '#FFA500B3', faIcon: 'fad fa-shovel', t: '1853' }, // Orange with 70% opacity
    { state: 'irrigation', color: '#1E90FFB3', faIcon: 'fad fa-sprinkler', t: '1854' }, // DodgerBlue with 70% opacity
    { state: 'weed control', color: '#FFFF00B3', faIcon: 'fad fa-flask-poison', t: '1855' }, // Yellow with 70% opacity
    { state: 'chemical treatment', color: '#800080B3', faIcon: 'fad fa-flask', t: '1856' }, // Purple with 70% opacity
    { state: 'pasture maintenance', color: '#98FB98B3', faIcon: 'fad fa-scythe', t: '1857' }, // PaleGreen with 70% opacity
    { state: 'cultivation/tillage', color: '#8B4513B3', faIcon: 'fad fa-digging', t: '1858' }, // SaddleBrown with 70% opacity
    { state: 'rotational grazing management', color: '#008080B3', faIcon: 'fad fa-sheep', t: '1859' }, // Teal with 70% opacity
    { state: 'drought management', color: '#D2B48CB3', faIcon: 'fad fa-hand-holding-water', t: '1860' }, // Tan with 70% opacity
    { state: 'cover cropping', color: '#3CB371B3', faIcon: 'fad fa-leaf', t: '1861' }, // MediumSeaGreen with 70% opacity
    { state: 'conservation set-aside', color: '#696969B3', faIcon: 'fad fa-tree', t: '1862' }, // DimGray with 70% opacity
]

export function pastureStateToColor(pastureState, fillOpacity = 'B3', strokeOpacity = 'FF') {
    pastureState = (pastureState || '').toLowerCase()
    const defaultState = PASTURE_STATES.find(state => state.state === 'resting')
    const defaultColors = {
        fillColor: defaultState.color.slice(0, -2) + fillOpacity,
        strokeColor: defaultState.color.slice(0, -2) + strokeOpacity,
    }
    const matchingState = PASTURE_STATES.find(state => state.state === pastureState)
    if (matchingState) {
        return {
            fillColor: matchingState.color.slice(0, -2) + fillOpacity,
            strokeColor: matchingState.color.slice(0, -2) + strokeOpacity,
            faIcon: matchingState.faIcon,
        }
    }
    return defaultColors
}

export function pastureStateEventsToColor(pastureState, fillOpacity = 'B3', strokeOpacity = 'FF') {
    pastureState = (pastureState || '').toLowerCase()
    const defaultState = pastureStateEvents.find(state => state.state === 'resting')
    const defaultColors = {
        fillColor: defaultState.color.slice(0, -2) + fillOpacity,
        strokeColor: defaultState.color.slice(0, -2) + strokeOpacity,
    }
    const matchingState = pastureStateEvents.find(state => state.state === pastureState)
    if (matchingState) {
        return {
            fillColor: matchingState.color.slice(0, -2) + fillOpacity,
            strokeColor: matchingState.color.slice(0, -2) + strokeOpacity,
            faIcon: matchingState.faIcon,
        }
    }
    return defaultColors
}

export const pastureStateEvents = [
    { state: 'baling', color: '#CD853FB3', faIcon: 'fad fa-box' }, // Peru with 70% opacity
    { state: 'burning', color: '#B22222B3', faIcon: 'fad fa-fire' }, // FireBrick with 70% opacity
    { state: 'clipping', color: '#90EE90B3', faIcon: 'fad fa-cut' }, // LightGreen with 70% opacity
    { state: 'compacting', color: '#708090B3', faIcon: 'fad fa-compress' }, // SlateGray with 70% opacity
    { state: 'cultivating', color: '#A0522DB3', faIcon: 'fad fa-digging' }, // Sienna with 70% opacity
    { state: 'cutting', color: '#DC143CB3', faIcon: 'fad fa-cut' }, // Crimson with 70% opacity
    { state: 'deferred', color: '#D3D3D3B3', faIcon: 'fad fa-pause' }, // LightGray with 70% opacity
    { state: 'feeding', color: '#FF4500B3', faIcon: 'fad fa-bone' }, // OrangeRed with 70% opacity
    { state: 'fertilising', color: '#FFA500B3', faIcon: 'fad fa-shovel' }, // Orange with 70% opacity
    { state: 'grazing', color: '#32CD32B3', faIcon: 'fad fa-sheep' }, // LimeGreen with 70% opacity
    { state: 'grooming', color: '#BC8F8FB3', faIcon: 'fad fa-brush' }, // RosyBrown with 70% opacity
    { state: 'harrowing', color: '#D2691EB3', faIcon: 'fad fa-broom' }, // Chocolate with 70% opacity
    { state: 'harvesting', color: '#DAA520B3', faIcon: 'fad fa-tractor' }, // GoldenRod with 70% opacity
    { state: 'hoeing', color: '#6B8E23B3', faIcon: 'fad fa-hand-holding-seedling' }, // OliveDrab with 70% opacity
    { state: 'levelling', color: '#778899B3', faIcon: 'fad fa-ruler-horizontal' }, // LightSlateGray with 70% opacity
    { state: 'maintenance', color: '#6A5ACDB3', faIcon: 'fad fa-tools' }, // SlateBlue with 70% opacity
    { state: 'mowing', color: '#228B22B3', faIcon: 'fad fa-leaf' }, // ForestGreen with 70% opacity
    { state: 'other', color: '#808080B3', faIcon: 'fad fa-ellipsis-h' }, // Gray with 70% opacity
    { state: 'pest management', color: '#808000B3', faIcon: 'fad fa-bug' }, // Olive with 70% opacity
    { state: 'ploughing', color: '#CD5C5CB3', faIcon: 'fad fa-tractor' }, // IndianRed with 70% opacity
    { state: 'repairing', color: '#7B68EEB3', faIcon: 'fad fa-wrench' }, // MediumSlateBlue with 70% opacity
    { state: 'reseeding', color: '#87CEFAB3', faIcon: 'fad fa-seedling' }, // LightSkyBlue with 70% opacity
    { state: 'resting', color: '#ADFF2FB3', faIcon: 'fad fa-campground' }, // GreenYellow with 70% opacity
    { state: 'rolling', color: '#9370DBB3', faIcon: 'fad fa-sync-alt' }, // MediumPurple with 70% opacity
    { state: 'scarifying', color: '#DEB887B3', faIcon: 'fad fa-broom' }, // BurlyWood with 70% opacity
    { state: 'seeding', color: '#B0E0E6B3', faIcon: 'fad fa-seedling' }, // PowderBlue with 70% opacity
    { state: 'smoothing', color: '#B0C4DEB3', faIcon: 'fad fa-sliders-h' }, // LightSteelBlue with 70% opacity
    { state: 'soil testing', color: '#5F9EA0B3', faIcon: 'fad fa-vial' }, // CadetBlue with 70% opacity
    { state: 'sowing', color: '#00FF7FB3', faIcon: 'fad fa-seedling' }, // SpringGreen with 70% opacity
    { state: 'spell grazing', color: '#66CDAAB3', faIcon: 'fad fa-magic' }, // MediumAquamarine with 70% opacity
    { state: 'spraying', color: '#00BFFFB3', faIcon: 'fad fa-spray-can' }, // DeepSkyBlue with 70% opacity
    { state: 'subsoiling', color: '#A52A2AB3', faIcon: 'fad fa-shovel' }, // Brown with 70% opacity
    { state: 'thinning', color: '#556B2FB3', faIcon: 'fad fa-minus' }, // DarkOliveGreen with 70% opacity
    { state: 'tilling', color: '#8B4513B3', faIcon: 'fad fa-digging' }, // SaddleBrown with 70% opacity
    { state: 'top cutting', color: '#FF6347B3', faIcon: 'fad fa-cut' }, // Tomato with 70% opacity
    { state: 'watering', color: '#4169E1B3', faIcon: 'fad fa-tint' }, // RoyalBlue with 70% opacity
    { state: 'weeding', color: '#FFFF00B3', faIcon: 'fad fa-seedling' }, // Yellow with 70% opacity
    { state: 'withholding', color: '#000000B3', faIcon: 'fad fa-ban' }, // Black with 70% opacity
]
